<template>
  <v-app id="inspire">
    <AdminHeader type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <AdminMenu/>
          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Создание</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Номенклатура /</span> {{type}} (создание) <span v-if="group_name">(Группа: {{ group_name }})</span></div>
                </div>
                <div>
                  <v-btn v-if="!nomenclature_id" class="button__success" :disabled="isLoading" @click="saveNomenclature">
                    Сохранить
                  </v-btn>
                  <v-btn v-else class="button__success" :disabled="isLoading" @click="updateNomenclature">
                    Изменить
                  </v-btn>
                  <v-btn v-if="nomenclature_id && new_nomenclature.flag_deletion" class="button" style="padding: 8px 20px !important; margin:0px !important; margin-left:10px;" @click="deleteNomenclature(false)">
                      Снять пометку на удаление
                    </v-btn>
                    <v-btn v-else-if="nomenclature_id" class="button__danger" style="padding: 8px 20px !important; margin:0px !important; margin-left:10px;" @click="deleteNomenclature(true)">
                      Удалить
                    </v-btn>
                </div>
              </v-col>
              <v-col cols="12">
                <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet border-gray">
                  <v-tabs
                      id="horizontal_tabs"
                      v-model="nomenclatureTab"
                      centered
                      height="40"
                  >
                    <v-tab v-for="item in nomenclatureType" :key="item.id" class="ml-4">
                      {{ item.name }}
                    </v-tab>
                  </v-tabs>
                </v-sheet>
              </v-col>

              <v-col cols="12" v-if="new_nomenclature && new_nomenclature.flag_deletion" >
                <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet border-gray" style="background:#f44336; opacity:0.4; display:flex; align-items:center; justify-content:center; color:white;">
                  <div>Удалено</div>
                </v-sheet>
              </v-col>

              <v-col>
                <v-tabs-items v-model="nomenclatureTab">
                  <v-tab-item>
                    <!-- <v-sheet rounded="lg" class="card">
                      <v-row>
                        <v-col md="4">
                          <label class="card-title">Тип</label>
                      
                                <v-text-field
                                    v-model="new_nomenclature.type"
                                    outlined
                                    dense
                                    style="height: 48px;margin-top: 10px"
                                    class="rounded-lg"
                                    readonly
                                ></v-text-field>
                        </v-col>
                        <v-col md="4">
                          <label class="card-title">Наименование</label>
                              <v-text-field
                                    v-model="new_nomenclature.name"
                                    label="Наименование"
                                    outlined
                                    dense
                                    style="height: 48px;margin-top: 10px"
                                    class="rounded-lg"
                                ></v-text-field>
                      
                        </v-col>
                        <v-col md="4">
                          <label class="card-title">Подразделение</label>
                          <v-select
                              v-model="new_nomenclature.department"
                              class="rounded-lg"
                              :items="(departmentList && departmentList.department) ? departmentList.department : []" item-title="name" item-value="id"
                              item-text="name"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              label="Подразделение"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              required
                              style="height: 48px; margin-top: 10px;"
                          ></v-select>
                        </v-col>
                

                           
                          
                      </v-row>
                    </v-sheet> -->
                


                    <v-row style="margin-top: 10px;">
                        <v-col md="6">
                          <v-sheet rounded="lg" class="card">

                            <v-row md="12">

                            
                            <v-col md="12">
                              <label class="card-title">Тип</label>
                          
                              <v-select
                                  v-model="new_nomenclature.type"
                                  :items="nomenclatureCreateType"
                                  item-text="name"
                                  item-value="id"
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  hide-details
                                  dense
                                  required
                                  color="#629F33"
                                  background-color="#fff"
                                  style="height: 48px;margin-top: 10px"
                                  @change="changeNomenCreate()"
                                  return-object
                              ></v-select>
                            </v-col>
                            <v-col md="12">
                              <label class="card-title">Наименование</label>
                                  <v-text-field
                                        v-model="new_nomenclature.name"
                                        label="Наименование"
                                        outlined
                                        dense
                                        style="height: 48px;margin-top: 10px"
                                        class="rounded-lg"
                                        required
                                      ref="requiredFields"
                                      :error="fieldErrors.name"
                                      :error-messages="fieldErrors.name ? ['Поле обязательно'] : []"
                                    ></v-text-field>
                          
                            </v-col>
                            <v-col md="12">
                              <label class="card-title">Подразделение</label>
                              <v-select
                                  v-model="new_nomenclature.department_id"
                                  class="rounded-lg"
                                  :items="(departmentList && departmentList.department) ? departmentList.department : []" item-title="name" item-value="id"
                                  item-text="name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Подразделение"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px; margin-top: 10px;"
                              ></v-select>
                            </v-col>

                            <v-col md="12">
                              <label class="card-title">Вид услуги</label>
                              <v-select
                                  v-model="new_nomenclature.service_type_of_service"
                                  class="rounded-lg"
                                  :items="service_type_of_service_list"
                                  item-text="name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выберите вид услуги"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                    ref="requiredFields"
                                    :error="fieldErrors.service_type_of_service"
                                    :error-messages="fieldErrors.service_type_of_service ? ['Поле обязательно'] : []"
                                  style="height: 48px; margin-top: 10px;"
                              ></v-select>
                            </v-col>

                            <v-col md="12">
                              <label class="card-title">Помещение по умолчанию</label>
                                <v-select
                                          v-model="new_nomenclature.service_room_by_default"
                                          class="rounded-lg"
                                          :items="rooms_list"
                                          item-value="id"
                                          item-text="name"
                                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                          label="Помещение"
                                          append-icon="mdi-chevron-down"
                                          outlined
                                          dense
                                          required
                                          style="height: 48px;"
                                 ></v-select>
                              </v-col>

                              <v-col md="12">
                                <label class="card-title">Длительность (мин)</label>
                                <v-select
                                          v-model="new_nomenclature.service_standard_time"
                                          class="rounded-lg"
                                          :items="time_list"
                                          item-value="id"
                                          item-text="name"
                                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                          label="Установите длительность"
                                          append-icon="mdi-chevron-down"
                                          outlined
                                          dense
                                          required
                                          style="height: 48px;"
                                 ></v-select>
                              </v-col>

                              <v-col md="12" style="display: flex; flex-direction: column;">
                                <label class="card-title">Цвет услуги</label>
                                <input type="color" id="color" v-model="new_nomenclature.color" />
                              </v-col>


                              <v-col md="12" style="display: flex; flex-direction: column;">

                                <label style="font-weight: 700; font-size:16px; line-height: 24px; margin-bottom: 5px;">
                                  Считать оказанной
                                </label>

                                  <v-btn-toggle
                                      v-model="service_toggle"
                                      mandatory
                                      class="rounded-lg"
                                      style="margin-top:5px;"
                                  >
                                    <v-btn style="padding: 25px 75px !important; background-color: #fff !important;" @click="new_nomenclature.service_write_off_when_selling = true">
                                      При продаже
                                    </v-btn>
                                    <v-btn style="padding: 25px 75px !important; background-color: #fff !important;" @click="new_nomenclature.service_write_off_when_selling = false, new_nomenclature.service_type_marks_of_arrival_for_occupation = 'АвтоматическиПриПосещенииКлуба'">
                                      В занятии
                                    </v-btn>

                                  </v-btn-toggle>

                                </v-col>

                                <v-col md="12" v-if="!new_nomenclature.service_write_off_when_selling">

                                  <label style="font-weight: 700; font-size:16px; line-height: 24px; margin-bottom: 5px;">
                                    Есть клиент
                                  </label>

                                  <v-select
                                          v-model="new_nomenclature.service_type_of_write_off_occupation"
                                          class="rounded-lg"
                                          :items="service_type_of_write_off_occupation_list"
                                          item-value="id"
                                          item-text="name"
                                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                          label="Установите длительность"
                                          append-icon="mdi-chevron-down"
                                          outlined
                                          dense
                                          required
                                          style="height: 48px;"
                                 ></v-select>

                                </v-col>

                                 <v-col md="12" v-if="!new_nomenclature.service_write_off_when_selling" style="display: flex; flex-direction: column;">

                                  <label style="font-weight: 700; font-size:16px; line-height: 24px; margin-bottom: 5px;">
                                    Отметка прибытия
                                  </label>

                                    <v-btn-toggle
                                        v-model="service_toggle"
                                        mandatory
                                        class="rounded-lg"
                                        style="margin-top:5px;"
                                    >
                                      <v-btn style="padding: 25px 75px !important; background-color: #fff !important;" @click="new_nomenclature.service_type_marks_of_arrival_for_occupation = 'АвтоматическиПриПосещенииКлуба'">
                                        Автоматически
                                      </v-btn>
                                      <v-btn style="padding: 25px 75px !important; background-color: #fff !important;" @click="new_nomenclature.service_type_marks_of_arrival_for_occupation = 'ОтмечаетТренер'">
                                        Вручную
                                      </v-btn>

                                    </v-btn-toggle>

                                  </v-col>


                          </v-row>


                          </v-sheet>
                
                          
                        </v-col>

                     


                        <v-col md="6">

                          <v-sheet rounded="lg" class="card" style="margin-bottom:10px;">
                            
                            <v-row>
                              <v-col md="12">
                                  <v-row md="12">
                                    <v-col md="10" style="display:flex; align-items: center;">
                                      <label class="card-title">В продаже</label>
                                    </v-col>
                                    <v-col md="2">
                                      <v-switch
                                        v-model="new_nomenclature.on_sale"
                                        style="height: 30px;"
                                        color="#629F33"
                                        inset
                                        @change="changePrice"
                                    ></v-switch>
                                    </v-col>
                                  </v-row>
                                  
                                </v-col>

                                <v-col md="12" v-if="new_nomenclature.on_sale">
                                  <v-row v-for="price_item in new_nomenclature.price_data" :key="price_item.type_of_price_id">
                                    <v-col md="5">
                                      <span>
                                        {{ price_item.price_name }}
                                      </span>
                                    </v-col>
                                    <v-col md="6">
                                      <v-text-field
                                          v-model="price_item.price"
                                          label="Цена"
                                          outlined
                                          dense
                                          style="height: 48px;"
                                          class="rounded-lg"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col md="1">
                                      <v-btn icon @click="removePrice(price_item.type_of_price_id)">
                                        <v-icon>mdi-close</v-icon>
                                      </v-btn>
                                    </v-col>

                                    
                                  </v-row>

                                  <v-row>
                                    <v-col style="display:flex; align-items:center; justify-content:space-between;">
                                      <v-btn
                                          class="button__lighten"
                                          @click="addPrice()"
                                      >
                                        <v-icon small class="mr-2">mdi-plus</v-icon>
                                        Добавить
                                      </v-btn>
                                      <v-btn
                                          class="button__lighten"
                                      >
                                        <v-icon small class="mr-2">mdi-clock</v-icon>
                                        История
                                      </v-btn>
                                    </v-col>
                                  </v-row>

                                </v-col>
                            </v-row>
                          </v-sheet>

                          <v-sheet rounded="lg" class="card">
                            <label class="card-title">При продаже</label>
                            <v-row>
                              <v-col md="12">
                                <v-checkbox
                                    v-model="new_nomenclature.employee_segment_for_selection_at_sale_id_value"
                                    label="Выбрать тренера из:"
                                    color="success"
                                ></v-checkbox>
                              </v-col>
                                  <v-col md="12">
                                    <v-select
                                        v-model="new_nomenclature.employee_segment_for_selection_at_sale_id"
                                        class="rounded-lg"
                                        :items="specialist_list"
                                        item-value="department.id"
                                        item-text="name"
                                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                        label="Сотрудники"
                                        append-icon="mdi-chevron-down"
                                        outlined
                                        dense
                                        required
                                        style="height: 48px;"
                                    ></v-select>
                                  </v-col>
                              <v-col md="12">
                                <v-checkbox
                                    v-model="new_nomenclature.allow_manual_discount_no_more_value"
                                    label="Ограничит ручную скидку"
                                    color="success"
                                ></v-checkbox>
                              </v-col>
                              <v-col md="12">
                                <v-row>
                                  <v-col md="3">
                                    <v-text-field
                                        v-if="new_nomenclature.allow_manual_discount_no_more_value"
                                        v-model="new_nomenclature.allow_manual_discount_no_more"
                                        label="Процент (%)"
                                        outlined
                                        dense
                                        style="height: 48px;"
                                        class="rounded-lg"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col md="12">
                                <v-checkbox
                                    v-model="new_nomenclature.allow_adjustment_prices"
                                    label="Разрешить корректировку цены"
                                    color="success"
                                    hide-details
                                ></v-checkbox>
                              </v-col>
                              <!-- <v-col md="12">
                                <v-checkbox
                                    v-model="new_nomenclature.membership_medical_certificate_required"
                                    label="Требуется медицинская справка"
                                    color="success"
                                    hide-details
                                ></v-checkbox>
                              </v-col> -->
                              <v-col md="12">
                                <v-checkbox
                                v-model="new_nomenclature.service_required_registration"
                                    label="Требуется основание для записи"
                                    color="success"
                                    hide-details
                                ></v-checkbox>
                              </v-col>

                             <!--  <v-col md="12">
                                <v-checkbox
                                    label="Резервирование при продаже"
                                    color="success"
                                    value="success"
                                    hide-details
                                ></v-checkbox>
                              </v-col> -->
                              <!-- <v-col md="12">
                                <v-select
                                    class="rounded-lg"
                                    :items="[]"
                                    item-value="type_id"
                                    item-text="type_name"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Продажа доступна сегменту"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    required
                                    style="height: 48px;"
                                ></v-select>
                              </v-col>
                              <v-col md="12">
                                <v-select
                                    class="rounded-lg"
                                    :items="[]"
                                    item-value="type_id"
                                    item-text="type_name"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Зачисление на лицевой счет"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    required
                                    style="height: 48px;"
                                ></v-select>
                              </v-col>
                              <v-col md="12">
                                <v-row>
                                  <v-col md="8">
                                    <v-text-field
                                        label="Сумма"
                                        outlined
                                        dense
                                        style="height: 48px;"
                                        class="rounded-lg"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col md="4">
                                    <v-select
                                        class="rounded-lg"
                                        :items="[]"
                                        item-value="type_id"
                                        item-text="type_name"
                                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                        label="Руб"
                                        append-icon="mdi-chevron-down"
                                        outlined
                                        dense
                                        required
                                        style="height: 48px;"
                                    ></v-select>
                                  </v-col> -->
                                <!-- </v-row>
                              </v-col> -->

                              <!-- <v-col md="12">
                                <v-select
                                    v-if="contract_list"
                                    v-model="new_nomenclature.contract_form"
                                    class="rounded-lg"
                                    :items="contract_list"
                                    item-value="id"
                                    item-text="name"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Бланк договора"
                                    append-icon="mdi-file"
                                    outlined
                                    dense
                                    required
                                    style="height: 48px;"
                                ></v-select>
                              </v-col> -->

                            </v-row> 
                          </v-sheet>
                          <!-- <v-sheet rounded="lg" class="card" style="margin-top:10px;">
                            <label class="card-title">CRM</label>
                            <v-row>
                              <v-col md="12">
                                <v-select
                                    v-model="new_nomenclature.membership_package_does_not_require_renewal"
                                    class="rounded-lg"
                                    :items="crm_list"
                                    item-value="id"
                                    item-text="name"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Продлевать любое членство"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    required
                                    style="height: 48px;"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-sheet> -->
<!-- 
                          <v-sheet rounded="lg" class="card" style="margin-top:10px;">
                            
                            <v-row>
                              <v-col md="12">
                                  <v-row md="12">
                                    <v-col md="10" style="display:flex; align-items: center;">
                                      <label class="card-title">Ограничения по помещениям СКУД</label>
                                    </v-col>
                                    <v-col md="2">
                                      <v-switch
                                        v-model="new_nomenclature.membership_restriction_on_rooms_value"
                                        style="height: 30px;"
                                        color="#629F33"
                                        inset
                                        @change="changeSkud"
                                    ></v-switch>
                                    </v-col>
                                  </v-row>
                                  
                                </v-col>

                                <v-col md="12" v-if="new_nomenclature.membership_restriction_on_rooms_value">
                                  <v-row v-for="skud_item in new_nomenclature.membership_access_to_room" :key="skud_item.id">
                                    <v-col md="11">
                                      <v-select
                                          v-model="skud_item.skud_id"
                                          class="rounded-lg"
                                          :items="rooms_list"
                                          item-value="id"
                                          item-text="name"
                                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                          label="Помещение"
                                          append-icon="mdi-chevron-down"
                                          outlined
                                          dense
                                          required
                                          style="height: 48px;"
                                      ></v-select>
                                    </v-col>
                                    <v-col md="1">
                                      <v-btn icon @click="removeSkud(skud_item.id)">
                                        <v-icon>mdi-close</v-icon>
                                      </v-btn>
                                    </v-col>

                                    
                                  </v-row>

                                  <v-row>
                                    <v-col style="display:flex; align-items:center; justify-content:space-between;">

                                      <v-btn
                                          class="button__lighten"
                                          @click="addSkud()"
                                      >
                                        <v-icon small class="mr-2">mdi-plus</v-icon>
                                        Добавить
                                      </v-btn>
                                
                                    </v-col>
                                  </v-row>

                                </v-col>
                            </v-row>
                          </v-sheet> -->

                          <v-sheet rounded="lg" class="card" style="margin-top:10px;">
                            
                            <v-row>
                              <v-col md="12">
                                  <v-row md="12">
                                    <v-col md="10" style="display:flex; align-items: center;">
                                      <label class="card-title">Онлайн продажа</label>
                                    </v-col>
                                    <v-col md="2">
                                      <v-switch
                                        v-model="new_nomenclature.online_sale"
                                        style="height: 30px;"
                                        color="#629F33"
                                        inset
                                        @change="changeOnlineSale"
                                    ></v-switch>
                                    </v-col>
                                  </v-row>
                                  
                                </v-col>

                                <v-col md="12" v-if="new_nomenclature.online_sale">
                                  <label>Категория в онлайн каталоге</label>
                                </v-col>
                                <v-col md="12" v-if="new_nomenclature.online_sale">
                                 
                                      <v-select
                                          v-model="new_nomenclature.group_online_sales_id"
                                          class="rounded-lg"
                                          :items="online_sale_list"
                                          item-value="id"
                                          item-text="name"
                                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                          label="Выберите категорию"
                                          append-icon="mdi-chevron-down"
                                          outlined
                                          dense
                                          required
                                          style="height: 48px;"
                                      ></v-select>
                                  </v-col>

                                  <v-col md="12" v-if="new_nomenclature.online_sale">
                                    <v-text-field
                                            v-model="new_nomenclature.online_sale_description"
                                            placeholder="Введите текст описания"
                                            outlined
                                            clearable
                                            textarea
                                            auto-grow
                                            rows="14"
                                          ></v-text-field>
                                  </v-col>


                            </v-row>
                          </v-sheet>

                        </v-col>


                    </v-row>
                  </v-tab-item>
             
                  <v-tab-item>
                    <v-card-title
                    style="background:#fff; width:100%;"
                              class="d-flex align-center"
                          >
                         
                            <v-btn
                                class="button__lighten ml-3"
                                @click="createNomenclatureSegmentUnitDetail"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>
                       
                            <v-btn
                                class="button__danger ml-3"
                                v-if="selectedLine && selectedLine.id"
                                @click="deleteNomenclatureSegmentUnit(selectedLine)"
                                style="margin: 0px 10px !important;"
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              <span v-if="selectedLine.deletion">Снять пометку на удаление</span>
                              <span v-else>Удалить</span>
                            </v-btn>
                            

                          </v-card-title>
                          <div class="scroll-table" style="background:#fff; width:100%; padding:20px 10px;">
                            <table id="table-1" cellpadding="1" style="background:#eee; width:100%; padding:10px;">
                              <thead>
                              <tr>
                                <th class="no-wrap">Сегмент</th>
                              </tr>
                              </thead>
                              <tbody>
                              <template v-if="nomenclature_segment_unit_list && nomenclature_segment_unit_list.length > 0">

                                <template v-for="line of nomenclature_segment_unit_list">
                                  <tr style="cursor:pointer; padding:10px;" :class="['parrent', { 'active-row': selectedLine && selectedLine.id === line.id }]" :key="line.id" @dblclick="detailNomenclatureSegmentUnit(line)" @click="setNomenOrg(line)">
                               
                                        <td style="align:left;">{{ line.name }}
                                          <span v-if="line.deletion" style="font-weight: bold; color: red;">X</span>
                                        </td>
                                        <!-- <td>{{ line.type }}</td> -->

                                  </tr>
                                </template>

                              </template>
                              </tbody>
                            </table>


                          </div>

                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>

                       
            <v-row justify="center">
              <v-dialog
                  v-model="nomenclatureSegmentUnitDialog"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Состав сегментов</h4>
                    </div>
                    <v-btn icon @click="nomenclatureSegmentUnitDialog = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                 
                        <v-row>
                          <v-col md="12">
                            <label>Сегмент</label>
                            
                            <v-select
                              v-model="new_nomenclature_segment_unit2.segment_id"
                              class="rounded-lg"
                              :items="nomenclature_segment_full_list ? nomenclature_segment_full_list : []" item-title="name" item-value="id"
                              item-text="name"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              label="Сегмент"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              required
                              style="height: 48px; margin-top: 10px;"
                          ></v-select>
                          </v-col>
                        </v-row>
                        
                        <v-row>
                          <v-col md="12">
                            <label>Обьект сегмента</label>
                            <!-- <v-text-field
                                v-model="new_nomenclature_segment_unit.object_id"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                                readonly
                            ></v-text-field> -->

                            <v-select
                                v-model="new_nomenclature_segment_unit2.object_id"
                                class="rounded-lg"
                                :items="nomenclature_choosed ? nomenclature_choosed : []" item-title="name" item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Обьект"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                return-object
                                style="height: 48px; margin-top: 10px;"
                            ></v-select>
                          </v-col>
                        </v-row>
                       
                        <v-row>
                          <v-col class="d-flex justify-end">

                            <div
                                v-if="new_nomenclature_segment_unit2.past_object_id"
                                class="button button__success"
                                style="cursor:pointer"
                                @click="updateNomenclatureSegmentUnit"
                            >
                              Изменить
                            </div>
                            <div
                                v-else
                                class="button button__success"
                                style="cursor:pointer"
                                @click="createNomenclatureSegmentUnit"
                            >
                              Сохранить
                            </div>

                            

                          </v-col>
                        </v-row>

                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            
          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AdminHeader from '@/components/Admin/AdminHeader.vue';
import AdminMenu from '@/components/Admin/AdminMenu.vue';
import {departmentActionTypes} from '@/store/modules/department';
import {lessonActionTypes} from "@/store/modules/lesson";
import {salesActionTypes} from "@/store/modules/sale";
import {mapState} from "vuex";
import {getItem, setItem} from "@/helpers/persistanceStorage";
import {nomenclatureActionTypes} from "@/store/modules/nomenclature";
export default {
  name: "CreateNomenclatureService",
  props: ['type','nomenclature_id','group_id','group_name','nomenclature_choosed'],
  components: {
    AdminHeader,
    AdminMenu
  },
  data() {
    return {
      nomenclatureCreateType: [
        {id: 'Членство', name: 'Членство', link:'CreateNomenclature'},
        {id: 'Пакет', name: 'Пакет', link:'CreateNomenclaturePacket'},
        {id: 'Модификатор', name: 'Модификатор', link:'CreateNomenclatureModifier'},
        {id: 'Услуга', name: 'Услуга', link:'CreateNomenclatureService'},
        {id: 'Аренда', name: 'Аренда', link:'CreateNomenclatureRental'},
        {id: 'Блюдо', name: 'Блюдо', link:'CreateNomenclatureDish'},
        {id: 'Запас', name: 'Запас', link:'CreateNomenclatureStore'}
      ],
      nomenclatureTab: 0,
      nomenclatureType: [
        {id: 0, name: 'Основное'},
        {id: 1, name: 'Состав сегментов'}
      ],
      new_nomenclature:{
        object_type:'Справочник.Номенклатура',
        package_type: "ОграниченКоличеством",
        type:null,
        name:null,
        name_full:null,
        department_id:null,
        services:[
          {
            id:0,
            service:null,
            type:0,
            count:null
          },
          {
            id:1,
            service:null,
            type:0,
            count:null
          }
        ],
        membership_number_of_frost_days:0,
        membership_number_of_guests_visits:0,
        membership_number_of_minimum_days_frost:0,
        membership_term_limit_actions:"СрокОграниченПериодом",
        membership_term_actions:null,
        membership_term_actions_type:'Месяц',
        membership_automatic_activate_type:null,
        membership_automatically_activate_upon_renewal:true,
        membership_automatically_activate_via:0,
        membership_limit_days_actions:0,
        membership_time_limit_actions:null,
        membership_time_limit_actions_value:false,
        membership_visits_not_more_actions_value:false,
        membership_visits_not_more_actions:null,
        membership_visits_not_more:0,
        membership_visits_not_more_type:null,
        package_type_number_of_visits:null,
        package_type_number_of_visits_actions:null,
        package_type_number_of_visits_actions_value:false,
        membership_time_of_action:[],
        price_data:[
          {
            type_of_price_id:"59115b58-9052-11eb-810c-6eae8b56243b",
            price_name:"Розничная",
            price:1
          }
        ],
        membership_medical_certificate_required:false,
        allow_adjustment_prices:false,
        allow_manual_discount_no_more:0,
        allow_manual_discount_no_more_value:false,
        contract_form:null,
        membership_package_does_not_require_renewal:null,
        membership_access_to_room:[],
        membership_restriction_on_rooms:null,
        membership_restriction_on_rooms_value:false,
        group_online_sales_id:null,
        online_sale_description:null,
        online_sale:false,
        on_sale:true,  
        package_type_count:1,
        package_pure_time:true,
        package_start_time:false,
        package_visits_time_visits_no_more:0,
        package_type_number_of_visits:0,
        employee_segment_for_selection_at_sale_id_value:false,
        employee_segment_for_selection_at_sale_id:null,
        package_cannot_be_used_without_active_membership:false,
        return_type:'Фиксировано',

        service_required_registration:false,
        service_type_of_service:null,
        service_room_by_default:null,
        service_standard_time:null,

        color:'#ffffff',
        service_write_off_when_selling:false,
        service_type_of_write_off_occupation:null,
        service_type_marks_of_arrival_for_occupation:null
      },
      service_type_of_write_off_occupation_list:[
        {
            id:"ВсегдаКромеРаннейОтмены",
            name:'Записан и не отменил'
        },
        {
            id:"ПоПрибытиюКлиента",
            name:'Записан и прибыл'
        },
        {
            id:"ПриНаличииПодтвержденияКлиента",
            name:'Записан. прибыл и подтвердил'
        },
      ],
      service_type_of_service_list:[
        {
            id:"АрендаЗала",
            name:'АрендаЗала'
        },
        {
            id:"ГрупповыеЗанятия",
            name:'ГрупповыеЗанятия'
        },
        {
            id:"ПерсональныеЗанятия",
            name:'ПерсональныеЗанятия'
        },
        {
            id:"ПрочиеУслуги",
            name:'ПрочиеУслуги'
        },
        {
            id:"УслугиСалона",
            name:'УслугиСалона'
        }
      ],
      membership_time_of_action_def:[
        {
          id:0,
          day_of_the_week:'Ежедневно',
          time_from:null,
          time_by:null
        }
      ],
      membership_time_of_action_array:[
        {
          id:'Ежедневно',
          name:'Ежедневно'
        },
        {
          id:'Понедельник',
          name:'Понедельник'
        },
        {
          id:'Вторник',
          name:'Вторник'
        },{
          id:'Среда',
          name:'Среда'
        },
        {
          id:'Четверг',
          name:'Четверг'
        },
        {
          id:'Пятница',
          name:'Пятница'
        },
        {
          id:'Суббота',
          name:'Суббота'
        },
        {
          id:'Воскресенье',
          name:'Воскресенье'
        },
        {
          id:'РабочиеДни',
          name:'Рабочие дни'
        },
        {
          id:'ВыходныеДни',
          name:'Выходные дни'
        },
        {
          id:'ПраздничныеДни',
          name:'Праздничные дни'
        }
      ],
      crm_list:[
        {
          id:0,
          name:'Продлевает любое членство'
        },
        {
          id:1,
          name:'Не требует продления'
        },
        {
          id:2,
          name:'Продлевает членство подразделения'
        }
      ],
      time_list: [
        '30',
        '60',
        '90',
        '120',
        '150',
        '180'
      ],
      timeArray: [
        '00:00','00:30','01:00','01:30',
        '02:00','02:30','03:00','03:30','04:00','04:30','05:00','05:30','06:00','06:30',
        '07:00','07:30','08:00','08:30','09:00','09:30','10:00','10:30','11:00','11:30',
        '12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30',
        '17:00','17:30','18:00','18:30','19:00','19:30','20:00','20:30','21:00','21:30','22:00',
        '22:30','23:00','23:30'
      ],
      specialist_def:[],
      services_def: [],
      services_segment_def:[],
      contract_list:[],
      rooms_list:[],
      specialist_list:[],
      online_sale_list:[
        {
          id:1,
          name:'Категория онлайн каталога'
        }
      ],
      membership_automatic_activate_type_list:[
          {
            id:"ВМоментПродажи",
            name:"В момент продажи"
          },
          {
            name:"Определяется при продаже",
            id:"АктивироватьДатойОпределяемойВПродаже"
          },
          {
            name:"При оплате",
            id:"АктивироватьПриОплате"
          },
          {
            name:"При первом посещении",
            id:"АктивироватьПриПосещении"
          }
        ],
      service_toggle:1,
      fieldErrors: {
          name: false,
          service_type_of_service: false
        },
        nomenclature_segment_unit_list:[
          {
            id:1,
            name:"тест",
            segment_id:null
          }
        ],
        new_nomenclature_segment_unit2:{
          object_id:null,
          segment_id:null
        },
        nomenclatureSegmentUnitDialog:false,
        selectedLine:null
    }
  },
  computed: {
    ...mapState({
      departmentList: state => state.department.departmentList,
      specialist: state => state.lesson.specialist,
      specialistGroup: state => state.lesson.specialistGroup,
      isLoading: state => state.sale.isLoading
    }),
    // Превращаем все уровни вложенности в плоский список
    flatItems(segm) {
      const result = [];
      const traverse = (arr) => {
        arr.forEach((el) => {
          result.push({ id: el.id, name: el.name });
          if (el.list && el.list.length) {
            traverse(el.list);
          }
        });
      };
 
      traverse(this.services_def);

      return result;
    },
    flatItems2(segm) {
      const result = [];
      const traverse = (arr) => {
        arr.forEach((el) => {
          result.push({ id: el.id, name: el.name });
          if (el.list && el.list.length) {
            traverse(el.list);
          }
        });
      };

      traverse(this.services_segment_def);
    
      return result;
    },
    selectedItem() {
      return this.flatItems.find((x) => x.id === this.selected);
    },
  },
  mounted() {
    setItem('admin_norm_type','nomenclature')

    console.log(this.type)
    this.new_nomenclature.type = {name:"Услуга",id:"Услуга",link:"CreateNomenclatureService"}

    if(this.group_id){
      this.new_nomenclature.group_id = this.group_id
    }

    if(this.nomenclature_id){
      console.log(this.nomenclature_id)
      this.$store.dispatch(nomenclatureActionTypes.getNomenclature, {id:this.nomenclature_id}).then((response) => {
            if(response && response.success) {
              this.new_nomenclature = response.nomenclature

              if((this.new_nomenclature.price || this.new_nomenclature.price === 0) && (!this.new_nomenclature.price_data || this.new_nomenclature.price_data.length === 0)){
                this.new_nomenclature.price_data = [
                  {
                    type_of_price_id:"59115b58-9052-11eb-810c-6eae8b56243b",
                    price_name:"Розничная",
                    price:this.new_nomenclature.price
                  }
                ]
              }

              if(this.new_nomenclature.department && this.new_nomenclature.department.id) {
                this.new_nomenclature.department_id = this.new_nomenclature.department.id
              } 

              this.new_nomenclature.type = {name:"Услуга",id:"Услуга",link:"CreateNomenclatureService"}

               //let get nomenclature segments list
               this.$store.dispatch(nomenclatureActionTypes.getNomenclatureSegmentsUnit,{nomenclature_id:this.nomenclature_id}
              ).then((response) => {
                if (response.success) {
                  this.nomenclature_segment_unit_list = response.nomenclature
                } else {
                  alert('Ошибка выполнения запроса! ' + response.error)
                }
              })
              this.$store.dispatch(nomenclatureActionTypes.getNomenclatureSegments,{}
              ).then((response) => {
                if (response.success) {
                  this.nomenclature_segment_full_list = response.nomenclature
                } else {
                  alert('Ошибка выполнения запроса! ' + response.error)
                }
              })

              if(this.nomenclature_choosed) {
                this.new_nomenclature_segment_unit2.object_id = this.nomenclature_choosed[0].id
              }

            }
      });
    }

    this.$store.dispatch(salesActionTypes.getSalesAllList, {}).then((response) => {
        if(response && response.success) {
          this.services_def = response.sales
        }
    });

    this.$store.dispatch(salesActionTypes.getSalesAllList, {type:'segment'}).then((response) => {
        if(response && response.success) {
          this.services_segment_def = response.sales
        }
    });

    this.$store.dispatch(lessonActionTypes.getSpecialistList,{})
      .then((response) => {
        if(response && response.success) {
          this.specialist_list = response.specialist
        }
    }); 

    this.$store.dispatch(salesActionTypes.getContractList, {type:'contract'}).then((response) => {
        if(response && response.success) {
          console.log(response.contracts)
          this.contract_list = response.contracts
        }
    });

    this.$store.dispatch(lessonActionTypes.getRoomList, {
                    for_admin: true
                  })
        .then((response) => {
          this.rooms_list = response.room
        })


        this.$store.dispatch(nomenclatureActionTypes.getOnlineGroups, {}).then((response) => {
            if(response && response.success) {
              this.online_sale_list = response.groups
            }
      });

      
   },
  methods: {
    setNomenOrg(item){
      if(this.selectedLine && this.selectedLine.id === item.id){
          this.selectedLine = null
        } else {
          this.selectedLine = item
        }
    },
    detailNomenclatureSegmentUnit(line){
      this.nomenclatureSegmentUnitDialog = true
      //this.new_nomenclature_segment_unit2 = line
      this.new_nomenclature_segment_unit2.past_segment_id = line.id
      this.new_nomenclature_segment_unit2.past_object_id = this.nomenclature_choosed[0].id
      this.new_nomenclature_segment_unit2.segment_id = line.id
      this.new_nomenclature_segment_unit2.object_id = this.nomenclature_choosed[0].id
    },
    deleteNomenclatureSegmentUnit(line,type){
      this.new_nomenclature_segment_unit2.past_object_id = line.id
      this.new_nomenclature_segment_unit2.object_id = line.id
      this.new_nomenclature_segment_unit2.remove = true
      this.new_nomenclature_segment_unit2.type = !type

      this.$store.dispatch(nomenclatureActionTypes.createNomenclatureSegmentsUnit,this.new_nomenclature_segment_unit2
              ).then((response) => {
                if (response.success) {

                  this.new_nomenclature_segment_unit2 = {
                    object_id:null,
                    segment_id:null
                  }

                  this.$store.dispatch(nomenclatureActionTypes.getNomenclatureSegmentsUnit,{nomenclature_id:this.nomenclature_id}
                  ).then((response2) => {
                    if (response2.success) {
                      this.nomenclature_segment_unit_list = response2.nomenclature

                      
                      this.nomenclatureSegmentUnitDialog = false

                    } else {
                      alert('Ошибка выполнения запроса! ' + response2.error)
                    }
                  })

                  

                } else {
                  alert('Ошибка выполнения запроса! ' + response.error)
                }
              })

    },
    createNomenclatureSegmentUnit(){

      this.new_nomenclature_segment_unit2 = {
        segment_id:this.new_nomenclature_segment_unit2.segment_id,
        object_id:this.new_nomenclature_segment_unit2.object_id
      }

      this.$store.dispatch(nomenclatureActionTypes.createNomenclatureSegmentsUnit,this.new_nomenclature_segment_unit2
              ).then((response) => {
                if (response.success) {

                  this.new_nomenclature_segment_unit2 = {
                    object_id:null,
                    segment_id:null
                  }

                  this.$store.dispatch(nomenclatureActionTypes.getNomenclatureSegmentsUnit,{nomenclature_id:this.nomenclature_id}
                  ).then((response2) => {
                    if (response2.success) {
                      this.nomenclature_segment_unit_list = response2.nomenclature

                      
                      this.nomenclatureSegmentUnitDialog = false

                    } else {
                      alert('Ошибка выполнения запроса! ' + response2.error)
                    }
                  })

                  

                } else {
                  alert('Ошибка выполнения запроса! ' + response.error)
                }
              })

    },
    updateNomenclatureSegmentUnit(){
      console.log(this.new_nomenclature_segment_unit2)

      this.$store.dispatch(nomenclatureActionTypes.createNomenclatureSegmentsUnit,this.new_nomenclature_segment_unit2
              ).then((response) => {
                if (response.success) {

                  this.new_nomenclature_segment_unit2 = {
                    object_id:null,
                    segment_id:null
                  }

                  this.$store.dispatch(nomenclatureActionTypes.getNomenclatureSegmentsUnit,{nomenclature_id:this.nomenclature_id}
                  ).then((response2) => {
                    if (response2.success) {
                      this.nomenclature_segment_unit_list = response2.nomenclature

                      
                      this.nomenclatureSegmentUnitDialog = false

                    } else {
                      alert('Ошибка выполнения запроса! ' + response2.error)
                    }
                  })

                  

                } else {
                  alert('Ошибка выполнения запроса! ' + response.error)
                }
              })

    },
    createNomenclatureSegmentUnitDetail(item){
      this.new_nomenclature_segment_unit = item
      this.nomenclatureSegmentUnitDialog = true
    },
    changeNomenCreate(){
      console.log(this.new_nomenclature)
      this.$router.push({
                                      name: this.new_nomenclature.type.link,
                                      params: {
                                        type: this.new_nomenclature.type.name
                                      }
                                    });
    },
      saveNomenclature(){

        let valid = true;

      // Проверяем каждое обязательное поле

      console.log(this.fieldErrors)

      // for (let key in this.fieldErrors) {
      //   if (!this.new_nomenclature[key]) {
      //     this.fieldErrors[key] = true;  // подсвечиваем
      //     valid = false;
      //   } else {
      //     this.fieldErrors[key] = false; // убираем подсветку
      //   }
      
      // }

      if (!this.new_nomenclature.name) {
        this.fieldErrors.name = true;
        valid = false;
      } else {
        this.fieldErrors.name = false;
      }

      if (!this.new_nomenclature.service_type_of_service) {
        this.fieldErrors.service_type_of_service = true;
        valid = false;
      } else {
        this.fieldErrors.service_type_of_service = false;
      }

      if(!valid){
        return
      }

      this.new_nomenclature.name_full = this.new_nomenclature.name
      //this.new_nomenclature.group_id = 'e69b4096-5ce3-11ed-8122-6cae8b562436'

      if(this.nomenclature_id){
        this.new_nomenclature.id = this.nomenclature_id
      }
      //this.new_nomenclature.visits_less_frequently_type = null

      this.$store.dispatch(nomenclatureActionTypes.saveNomenclature, this.new_nomenclature).then((response) => {
        if(response && response.success) {
          if(response.nomenclature && response.nomenclature.id){
            this.$router.push({
              name: 'AdminNormatives',
              params: {
                new_nomenclature_id: response.nomenclature.id
              }
            });
          }
        } else {
          alert('Ошибка выполнения запроса! ' + response.error)
        }
      });

      console.log(this.new_nomenclature)


    },
    deleteNomenclature(status){
      this.$store.dispatch(nomenclatureActionTypes.saveNomenclature,{id:this.nomenclature_id,remove:true,remove_type:status}
      ).then((response) => {
        if (response.success) {
          if(response.nomenclature && response.nomenclature.object_id){
            this.$router.push({
              name: 'AdminNormatives',
              params: {
                new_nomenclature_id: response.nomenclature.object_id
              }
            });
          }
        } else {
          alert('Ошибка выполнения запроса! ' + response.error)
        }
      })
    },
    updateNomenclature(){
      this.new_nomenclature.name_full = this.new_nomenclature.name
      //this.new_nomenclature.group_id = 'e69b4096-5ce3-11ed-8122-6cae8b562436'

      if(this.nomenclature_id){
        this.new_nomenclature.id = this.nomenclature_id
      }
      //this.new_nomenclature.visits_less_frequently_type = null

      this.$store.dispatch(nomenclatureActionTypes.saveNomenclature, this.new_nomenclature).then((response) => {
        if(response && response.success) {
          if(response.nomenclature && response.nomenclature.id){
            this.$router.push({
              name: 'AdminNormatives',
              params: {
                new_nomenclature_id: response.nomenclature.id
              }
            });
          }
        } else {
          alert('Ошибка выполнения запроса! ' + response.error)
        }
      });
    },
    // Кастомная фильтрация по названию и категории
    customFilter(item, queryText) {
      return item.name.toLowerCase().includes(queryText.toLowerCase());
    },
    addService(){
      let newObj =   {
            id:Date.now(),
            service:null,
            type:0,
            count:0
          }
      this.new_nomenclature.services.push(newObj)
    },
    removeService(item_id){
   
      if(this.new_nomenclature.services.length > 1){
        this.new_nomenclature.services.splice(this.new_nomenclature.services.findIndex(n => n.id === item_id),1);
      }

    },
    changeState(id) {
      if(id === true){
        this.new_nomenclature.membership_time_limit_actions = "ВремяОграничено"
        let newObj =   {
            id:Date.now(),
            day_of_the_week:'Ежедневно',
            time_from:null,
            time_by:null
          }
      this.new_nomenclature.membership_time_of_action.push(newObj)
      }else{
        this.new_nomenclature.membership_time_limit_actions = "Неопределено"
        this.new_nomenclature.membership_time_of_action = []
      }
    },
    changeStateVisits(id) {
      if(id === true){
        this.new_nomenclature.membership_visits_not_more_actions = "ОграниченЧастотой"
      }else{
        this.new_nomenclature.membership_visits_not_more_actions = "Неопределено"
      }
    },
    changeStatePackage(id) {
      if(id === true){
        this.new_nomenclature.package_type_number_of_visits_actions = "ОграниченПосещениями"
      }else{
        this.new_nomenclature.package_type_number_of_visits_actions = "Неопределено"
      }
    },
    addTime(){
      let newObj =   {
            id:Date.now(),
            day_of_the_week:'Ежедневно',
            time_from:null,
            time_by:null
          }
      this.new_nomenclature.membership_time_of_action.push(newObj)
    },
    removeTime(item_id){
   
      if(this.new_nomenclature.membership_time_of_action.length > 1){
        this.new_nomenclature.membership_time_of_action.splice(this.new_nomenclature.membership_time_of_action.findIndex(n => n.id === item_id),1);
      }

    },
    addPrice(){
      let newObj = {
            type_of_price_id:"59115b57-9052-11eb-810c-6eae8b56243b",
            price_name:"Закупочная",
            price:1
          }

          if(this.new_nomenclature.price_data.length < 2){
            this.new_nomenclature.price_data.push(newObj)
          }
    },
    removePrice(item_id){
   
      if(this.new_nomenclature.price_data.length > 1){
        this.new_nomenclature.price_data.splice(this.new_nomenclature.price_data.findIndex(n => n.id === item_id),1);
      }

    },
    changePrice(id) {
      if(id === true){
        let newObj =   {
            type_of_price_id:"59115b58-9052-11eb-810c-6eae8b56243b",
            price_name:"Розничная",
            price:1
          }
        this.new_nomenclature.price_data.push(newObj)
      }else{
        this.new_nomenclature.price_data = []
      }
    },

    addSkud(){
      let newObj = {
            id:Date.now(),
            name:null,
            skud_id:null
          }

        this.new_nomenclature.membership_access_to_room.push(newObj)
    },
    removeSkud(item_id){
   
      if(this.new_nomenclature.membership_access_to_room.length > 1){
        this.new_nomenclature.membership_access_to_room.splice(this.new_nomenclature.membership_access_to_room.findIndex(n => n.id === item_id),1);
      }

    },
    changeSkud(id) {
      if(id === true){
        let newObj =   {
            id:Date.now(),
            name:null,
            skud_id:null
          }
        this.new_nomenclature.membership_access_to_room.push(newObj)
        this.new_nomenclature.membership_restriction_on_rooms = 'ДоступОграниченПомещениями'
      }else{
        this.new_nomenclature.membership_access_to_room = []
        this.new_nomenclature.membership_restriction_on_rooms = null
      }
    },
    changeOnlineSale(){

    }
  }
}
</script>

<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-transform: none;
}
.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0!important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
  min-width: 64px !important;
}
.active-row td {
  background-color: #bbdefb !important; /* светло-голубой */
}
#table-1 tbody tr.active-row {
  background-color: #bbdefb !important;
}
.scroll-table{
    line-height: 1.5;
    font-family: Circe;
    color: rgba(0, 0, 0, 0.87);
    background-repeat: no-repeat;
    box-sizing: inherit;
    padding: 0;
    margin: 0;
    overflow-x: auto;
    border-bottom: 1px solid #E0E0E0;
}

.scroll-table table {
    line-height: 1.5;
    font-family: Circe;
    color: rgba(0, 0, 0, 0.87);
    background-repeat: no-repeat;
    box-sizing: inherit;
    padding: 0;
    margin: 0;
    border-collapse: collapse;
    min-width: 100%;
}

.scroll-table table th:first-child, .scroll-table table td:first-child {
    border-collapse: collapse;
    box-sizing: inherit;
    margin: 0;
    vertical-align: top;
    background: #fff;
    padding: 10px 12px;
    text-align: left;
    font-family: "Circe";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #000000;
    border: 1px solid #E0E0E0 !important;
    border-left: 0 !important;
}

.scroll-table table th {
  background: #fff;
    padding: 10px 12px;
    text-align: left;
    font-family: "Circe";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #000000;
    border: 1px solid #E0E0E0 !important;
}

.scroll-table table th, .scroll-table table td {
    background: #fff;
    padding: 10px 12px;
    text-align: left;
    font-family: "Circe";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #000000;
    border: 1px solid #E0E0E0 !important;
}
</style>